<ngx-charts-pie-chart [view]="view" [scheme]="'vivid'" [results]="data" [gradient]="gradient" [legend]="showLegend"
  [legendPosition]="legendPosition" [labels]="showLabels" [trimLabels]="true" [maxLabelLength]="'40'"
  [doughnut]="isDoughnut" [arcWidth]="'0.4'" [legendTitle]="''" [customColors]="customColors">
  <ng-template #tooltipTemplate let-model="model">
    <div class="tooltip-hours">
      <span style="font-size: 16px;">{{ model.name }}</span>
      <br /> {{ model.value }}h of {{totalHoursAssigned}}h
      <br /> {{ ((model.value / totalHoursAssigned) * 100).toFixed(2) }}%
    </div>
  </ng-template>
</ngx-charts-pie-chart>
<div class="spent-value" [ngClass]="{'small-spent-value': totalSpent < 10, 'big-spent-value': totalSpent == 100}"><span
    style="font-size: 28px">{{totalSpent}}%</span> <br /> <strong style="font-size: 16px;">ASSIGNED</strong></div>